
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es/renting-seminuevos",
      function () {
        return require("private-next-pages/es/renting-seminuevos.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es/renting-seminuevos"])
      });
    }
  